import type { Backend } from '@freelancer/datastore/core';
import {
  OrderByDirection,
  getQueryParamValue,
} from '@freelancer/datastore/core';
import { toNumber } from '@freelancer/utils';
import type { CanvasCollection } from './canvas.types';

export function canvasBackend(): Backend<CanvasCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    },
    fetch: (_authUid, id, query, _order) => {
      const canvasId = id ? toNumber(id[0]) : undefined;
      const contextId = getQueryParamValue(query, 'contextId')[0];
      const contextType = getQueryParamValue(query, 'contextType')[0];
      const createdBy = getQueryParamValue(query, 'createdBy')[0];

      if (canvasId && (contextId || contextType)) {
        throw new Error('Cannot provide both Canvas ID and context parameters');
      } else if (!!contextId !== !!contextType) {
        throw new Error(
          'Context ID and Context Type must be provided together; either supply both, or leave both empty.',
        );
      }

      const params = {
        ...(canvasId && { id: canvasId }),
        ...(contextId &&
          contextType && {
            context_id: contextId,
            context_type: contextType,
          }),
        ...(createdBy && { user_id: _authUid }),
        title_search_query: query?.searchQueryParams.title_search_query,
        visibility: query?.searchQueryParams.visibility,
      };

      return {
        endpoint: 'canvas/0.1/canvas',
        params,
      };
    },
    push: (_, canvas) => {
      if (!canvas.contextId || !canvas.contextType) {
        throw new Error(
          'Context ID and Context Type must be provided to create a smart canvas',
        );
      }

      return {
        endpoint: 'canvas/0.1/canvas',
        method: 'POST',
        payload: {
          context_id: canvas.contextId,
          context_type: canvas.contextType,
        },
      };
    },
    set: undefined,
    update: (_, delta, originalDocument) => {
      if (!originalDocument.id) {
        throw new Error('Canvas ID is required to update a canvas');
      }

      return {
        endpoint: `canvas/0.1/canvas/${originalDocument.id}`,
        method: 'PUT',
        payload: {
          ...delta,
          id: originalDocument.id,
        },
      };
    },
    remove: undefined,
  };
}
